import React from 'react';
import { Icon, Modal, Spin, Timeline } from 'antd';
import { useHistoryQuery } from '../../../hooks/useHistoryAddressQuery';
import { useSelector } from 'react-redux';
import { ReactComponent as HistoryIcon} from '../../../../../resource/forms/History.svg';
import moment from 'moment';

const WithModalRoomStage = ({ visible, onOk, onCancel }) => {
  const currentFlat = useSelector(
    (state) => state.housingStockStore.currentFlat
  );

  const { data: historyArrayQuery, loading: loadingHistoryQuery } =
    useHistoryQuery(
      {
        flatId: currentFlat?.addressId,
      },
      {
        staleTime: 0,
        enabled: Boolean(currentFlat && visible),
        select: (data) => data?.historyAddressLifeCycles,
      }
    );

  const historyArray = historyArrayQuery || [];

  const timeLineItems = nodes => nodes.map(el => {				    
    return <Timeline.Item color="#005ebe" key={el.changeId} >          
      <div><span style={{fontSize: 12, fontWeight: "bold", color: "#666"}}>
        {moment(el.dateChange).format("DD.MM.YYYY HH:mm")}
        </span>
           <span style={{marginLeft: 10, marginRight: 10}}>{el.operation}</span>
           <span><Icon  style={{ color: "#0066e4" }} type="user" /></span>
            <span style={{marginLeft: 5, color: "#0066e4"}}>{el.name}</span></div>
      <div><span><Icon  style={{ color: "#00877e" }} type="caret-right" /></span>
            <span style={{marginLeft: 5}}>{el.newValue}</span></div>
    </Timeline.Item>
            
});

  return (
    <Modal
      footer={null}
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
      title={<span style={{color: "#0995ed" }}> <HistoryIcon 
                  style={{ height: 40, verticalAlign:'middle', marginRight: 10 }}/>История изменений помещения {currentFlat?.addressId}</span>}
    >
      <Spin spinning={loadingHistoryQuery} tip="..." size="default">
        <div style={{ maxHeight: '65vh', overflowY: "auto", paddingTop: '5px'}}>
          {historyArray && historyArray.length > 0 ? 
            <Timeline>
              {timeLineItems([...historyArray].reverse())}
            </Timeline>
            : (
              <div
              style={{
                color: 'gray',
                fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                fontSize: '16px',
                fontWeight: 400,
                textAlign: 'center'
              }}
              >
                Без изменений
              </div>
            )
          }
        </div>
      </Spin>
    </Modal>
  );
};

export default WithModalRoomStage;
